import { render, staticRenderFns } from "./optionDialog.vue?vue&type=template&id=5c524140&scoped=true&"
import script from "./optionDialog.vue?vue&type=script&lang=js&"
export * from "./optionDialog.vue?vue&type=script&lang=js&"
import style0 from "./optionDialog.vue?vue&type=style&index=0&id=5c524140&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c524140",
  null
  
)

export default component.exports